import {Dimensions} from 'react-native';

import { cf } from './cf';
import { ce } from './ce';
import { ic } from './ic';
import { cp } from './cp';
import { ip } from './ip';
import { bf } from './bf';

export class iv { // individual view def
    //
/*
    static get_iniPageInfs(p_am1d_key, p_roleKey) {
        //
        if (p_roleKey == "10") { // キャストの場合
            return {
                sgc_pageRole: 'cast',
                sgc_pageName: 'iUserDtl',
                sgc_pageKey: global.c?.state.sgc_cm10_key,
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
                sgcb_pageEdt: false,
            };
        }
        else if (p_roleKey == "90" || p_roleKey == "80") { // 管理者の場合
            return {
                sgc_pageRole: 'own1',
                sgc_pageName: 'iCpyList',
                sgc_pageKey: '',
                sgc_pageMode: 'show',
                sgc_pagePrc: '',
                sgcb_pageEdt: false,
            };
        }
        else { // その他の場合
            alert('get_iniPageInfs: no iniPageInfs at ic.js');
        }
    };
*/

    static get_iniPageInfs(p_am1d_key, p_roleKey) {
        //
        if (p_roleKey == "10") { // キャストの場合
          return {
            sgc_pageRole: 'cast',
            sgc_pageName: 'iUserDtl',
            sgc_pageMode: 'show',
          };
        }
        else if (p_roleKey == "90" || p_roleKey == "80") { // 管理者の場合
          return {
            sgc_pageRole: 'own1',
            sgc_pageName: 'iCpyList',
            sgc_pageMode: 'show',
          };
        }
        else { // その他の場合
            alert('get_iniPageInfs: no iniPageInfs at ic.js');
        }
    };
    static get_iniPageRole(p_userRole, p_pageName) {
        //
        let _r = '';
        //
        switch (p_userRole) {
            case '10': // 'cast'
                _r = 'cast'
                break;
            case '80': // '事務担当者'
            case '90': // '店舗運営者'
                switch (p_pageName) {
                    case 'iCpyList':
                        _r = 'own1';
                        break;
                    case 'iCpyDtl':
                    case 'iPdtList':
                    case 'iPdtDtl':
                    case 'iOdrDtl':
                    case 'iSeatList':
                    case 'iSeatDtl':
                    case 'iUserList':
                    case 'iCmrList':
                    case 'iCmrDtl':
                    case 'iMthList':
                    case 'iMthDtl':
                    case 'iDayDtl':
                        _r = 'own2';
                        break;
                    case 'iUserDtl':
//                    case 'iRslList':
                    case 'iDayList':
                    case 'iSrvList':
                    case 'iSrvDtl':
                        _r = 'own3';
                        break;
                        break;
                    case 'cLgn':
                    default:
                        break;
                }
                break;
            default:
                break;
        }
        return _r;        
    };

/*
    static get_bwdPageInfs() {
        //
        let _r = {
            sgc_pageRole: global.c?.state.sgc_pageRole,
            sgc_pageMode: 'show',
        };
        //
        const _pageName = cf.myNV_get_name();
        //
        switch (_pageName) {
            case 'iCpyDtl':
                _r.sgc_pageName = 'iCpyList';
                break;
            case 'iPdtDtl':
                _r.sgc_pageName = 'iPdtList';
                break;
            case 'iOdrDtl':
                _r.sgc_pageName = 'iSrvDtl';
                break;
            case 'iSeatDtl':
                _r.sgc_pageName = 'iSeatList';
                break;
            case 'iCmrDtl':
                _r.sgc_pageName = 'iCmrList';
                break;
            case 'iSrvDtl':
                _r.sgc_pageName = 'iSrvList';
                break;
            case 'iUserDtl':
                _r.sgc_pageName = 'iUserList';
                break;
            case 'iMthDtl':
                _r.sgc_pageName = 'iMthList';
                break;
            case 'iDayDtl':
                _r.sgc_pageName = 'iMthDtl';
                break;
            default:
                break;
        }
        return _r;        
    }; 
*/

    static _get_hdrPfx = (p_pfx) => {
        let _sfx = '';
        switch (global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName]) {
            case 'new':
                _sfx = '新規';
                break;
            case 'edit':
            case 'show':
                switch (global.c?.state.sgc_pageRole) {
                    case 'own1':
                        _sfx = '全体共通';
                        break;
                    case 'own2':
//                        _sfx = global.c?.state.sgcd_pageCmns?.cm20c310 ?? '';
//                        _sfx = global.c?.state.sgcd_pageCmns?.cm20c310 || '';
//                        _sfx = global.c?.state.sgcd_pageCmns?.cm20c330 || '';
                        _sfx = global.c?.state.sgcd_pageCmns?.cm20_pfx || '';
                        break;
                    case 'own3':
                    case 'cast':
//                        _sfx = global.c?.state.sgcd_pageCmns?.cm10c310 ?? '';
//                        _sfx = global.c?.state.sgcd_pageCmns?.cm10c330 || '';
                        _sfx = global.c?.state.sgcd_pageCmns?.cm10_pfx || '';
                        break;
                    default:
                        break;
                };
                break;
            default:
                _sfx = '';
                break;
        };
        return `{}
{}`.f(p_pfx, _sfx)
    };
    
    static gdd_ftrDefss = { // ftr のメニュー構成, arrow-right, building, check, close, ellipsis-v, envelope, file-text, gear, pencil, plus, search, send, sign-out, sliders, tasks, th-large, th-list, th, trash, user, users
        cast: {
          iUserDtl: {
            type:'iconPfx', 
            iconName: 'user',
            pfx:'スタッフ情報',
            role: 'cast',
            page:'iUserDtl',
            sgcd_pageCmns: {
            },
            d_leftBtns: {
              b_vsb: false,
              iconName: null,
              pfx: null,
              d_pageInfs: null,
              onPrs: null,
            },
          },
          iSrvList: {
            type:'iconPfx', 
            iconName: 'list-alt',
            pfx:'入席一覧',
            role: 'cast',
            page:'iSrvList',
            sgcd_pageCmns: {
            },
            d_leftBtns: {
              b_vsb: false,
              iconName: null,
              pfx: null,
              d_pageInfs: null,
              onPrs: null,
            },
          },
          iSrvDtl: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'list-alt',
            pfx:'入席情報',
            role: 'cast',
            page:'iSrvDtl',
            sgcd_pageCmns: {
            },
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '戻る',
              d_pageInfs: {
                sgc_pageRole: 'cast',
                sgc_pageName: 'iSrvList',
                sgc_pageMode: 'show',
              },
              onPrs: null,
            },
          },
          logout: {
            type:'iconPfx', 
            iconName: 'sign-out',
            pfx:'ログアウト',
            role: '',
            fnc: 'logout',
          },
        },
        own1: {
          iCpyList: {
            type:'iconPfx', 
            iconName: 'building',
            pfx:'店舗一覧',
            role: 'own1',
            page:'iCpyList',
            sgcd_pageCmns: {
            },
            d_leftBtns: {
              b_vsb: false,
              iconName: null,
              pfx: null,
              d_pageInfs: null,
              onPrs: null,
            },
          },
          iCpyDtl: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'building',
            pfx:'店舗詳細',
            role: 'own1',
            page:'iCpyDtl',
            sgcd_pageCmns: {
            },
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '戻る',
              d_pageInfs: {
                sgc_pageRole: 'own1',
                sgc_pageName: 'iCpyList',
                sgc_pageMode: 'show',
              },
              onPrs: null,
            },
          },
          logout: {
            type:'iconPfx', 
            iconName: 'sign-out',
            pfx:'ログアウト',
            role: '',
            fnc: 'logout',
          },
        },
        own2: {
            iCpyDtl: {
              type:'iconPfx', 
              iconName: 'building',
              pfx:'店舗詳細',
              role: 'own2',
              page:'iCpyDtl',
              sgcd_pageCmns: {
              },
              d_leftBtns: {
                b_vsb: true,
                iconName: 'arrow-left',
                pfx: '店舗一覧',
                d_pageInfs: {
                  sgc_pageRole: 'own1',
                  sgc_pageName: 'iCpyList',
                  sgc_pageMode: 'show',
                },
                onPrs: null,
              },
            },
            iMthList: {
              type:'iconPfx', 
              iconName: 'lock',
              pfx:'レジ一覧',
              role: 'own2',
              page:'iMthList',
              sgcd_pageCmns: {
              },
              d_leftBtns: {
                b_vsb: true,
                iconName: 'arrow-left',
                pfx: '店舗一覧',
                d_pageInfs: {
                  sgc_pageRole: 'own1',
                  sgc_pageName: 'iCpyList',
                  sgc_pageMode: 'show',
                },
                onPrs: null,
              },
            },
            iMthDtl: {
              b_vsb: false,
              type:'iconPfx', 
              iconName: 'lock',
              pfx:'',
              role: 'own2',
              page:'iMthDtl',
              sgcd_pageCmns: {
              },
              d_leftBtns: {
                b_vsb: true,
                iconName: 'arrow-left',
                pfx: '戻る',
                d_pageInfs: {
                  sgc_pageRole: 'own2',
                  sgc_pageName: 'iMthList',
                  sgc_pageMode: 'show',
                },
                onPrs: null,
              },
            },
            iDayDtl: {
              b_vsb: false,
              type:'iconPfx', 
              iconName: 'lock',
              pfx:'',
              role: 'own2',
              page:'iDayDtl',
              sgcd_pageCmns: {
              },
              d_leftBtns: {
                b_vsb: true,
                iconName: 'arrow-left',
                pfx: '戻る',
                d_pageInfs: {
                  sgc_pageRole: 'own2',
                  sgc_pageName: 'iMthDtl',
                  sgc_pageMode: 'show',
                },
                onPrs: null,
              },
            },
            iCmrList: {
              type:'iconPfx', 
              iconName: 'address-card',
              pfx:'入店時刻一覧',
              role: 'own2',
              page:'iCmrList',
              sgcd_pageCmns: {
              },
              d_leftBtns: {
                b_vsb: true,
                iconName: 'arrow-left',
                pfx: '店舗一覧',
                d_pageInfs: {
                  sgc_pageRole: 'own1',
                  sgc_pageName: 'iCpyList',
                  sgc_pageMode: 'show',
                },
                onPrs: null,
              },
            },
            iCmrDtl: {
              b_vsb: false,
              type:'iconPfx', 
              iconName: 'address-card',
              pfx:'入店時刻情報',
              role: 'own2',
              page:'iCmrDtl',
              sgcd_pageCmns: {
              },
              d_leftBtns: {
                b_vsb: true,
                iconName: 'arrow-left',
                pfx: '戻る',
                d_pageInfs: {
                  sgc_pageRole: 'own2',
                  sgc_pageName: 'iCmrList',
                  sgc_pageMode: 'show',
                },
                onPrs: null,
              },
            },
            iUserList: {
              type:'iconPfx', 
              iconName: 'users',
              pfx:'スタッフ一覧',
              role: 'own2',
              page:'iUserList',
              sgcd_pageCmns: {
              },
              d_leftBtns: {
                b_vsb: true,
                iconName: 'arrow-left',
                pfx: '店舗一覧',
                d_pageInfs: {
                  sgc_pageRole: 'own1',
                  sgc_pageName: 'iCpyList',
                  sgc_pageMode: 'show',
                },
                onPrs: null,
              },
            },
            iUserDtl: {
              b_vsb: false,
              type:'iconPfx', 
              iconName: 'users',
              pfx:'スタッフ情報',
              role: 'own2',
              page:'iUserDtl',
              sgcd_pageCmns: {
              },
              d_leftBtns: {
                b_vsb: true,
                iconName: 'arrow-left',
                pfx: '戻る',
                d_pageInfs: {
                  sgc_pageRole: 'own2',
                  sgc_pageName: 'iUserList',
                  sgc_pageMode: 'show',
                },
                onPrs: null,
              },
            },
            iSeatList: {
              type:'iconPfx', 
              iconName: 'book',
              pfx:'バインダ一覧',
              role: 'own2',
              page:'iSeatList',
              sgcd_pageCmns: {
              },
              d_leftBtns: {
                b_vsb: true,
                iconName: 'arrow-left',
                pfx: '店舗一覧',
                d_pageInfs: {
                  sgc_pageRole: 'own1',
                  sgc_pageName: 'iCpyList',
                  sgc_pageMode: 'show',
                },
                onPrs: null,
              },
            },
            iSeatDtl: {
              b_vsb: false,
              type:'iconPfx', 
              iconName: 'book',
              pfx:'バインダ情報',
              role: 'own2',
              page:'iSeatDtl',
              sgcd_pageCmns: {
              },
              d_leftBtns: {
                b_vsb: true,
                iconName: 'arrow-left',
                pfx: '戻る',
                d_pageInfs: {
                  sgc_pageRole: 'own2',
                  sgc_pageName: 'iSeatList',
                  sgc_pageMode: 'show',
                },
                onPrs: null,
              },
            },

            iPdtCtgList: {
              type:'iconPfx', 
              iconName: 'th',
              pfx:'商品分類一覧',
              role: 'own2',
              page:'iPdtCtgList',
              sgcd_pageCmns: {
              },
              d_leftBtns: {
                b_vsb: true,
                iconName: 'arrow-left',
                pfx: '店舗一覧',
                d_pageInfs: {
                  sgc_pageRole: 'own1',
                  sgc_pageName: 'iCpyList',
                  sgc_pageMode: 'show',
                },
                onPrs: null,
              },
            },
            iPdtCtgDtl: {
              b_vsb: false,
              type:'iconPfx', 
              iconName: 'th-list',
              pfx:'商品分類情報',
              role: 'own2',
              page:'iPdtCtgDtl',
              sgcd_pageCmns: {
              },
              d_leftBtns: {
                b_vsb: true,
                iconName: 'arrow-left',
                pfx: '戻る',
                d_pageInfs: {
                  sgc_pageRole: 'own2',
                  sgc_pageName: 'iPdtCtgList',
                  sgc_pageMode: 'show',
                },
                onPrs: null,
              },
            },

            iPdtList: {
              type:'iconPfx', 
              iconName: 'list',
              pfx:'商品一覧',
              role: 'own2',
              page:'iPdtList',
              sgcd_pageCmns: {
              },
              d_leftBtns: {
                b_vsb: true,
                iconName: 'arrow-left',
                pfx: '店舗一覧',
                d_pageInfs: {
                  sgc_pageRole: 'own1',
                  sgc_pageName: 'iCpyList',
                  sgc_pageMode: 'show',
                },
                onPrs: null,
              },
            },
            iPdtDtl: {
              b_vsb: false,
              type:'iconPfx', 
              iconName: 'list',
              pfx:'商品情報',
              role: 'own2',
              page:'iPdtDtl',
              sgcd_pageCmns: {
              },
              d_leftBtns: {
                b_vsb: true,
                iconName: 'arrow-left',
                pfx: '戻る',
                d_pageInfs: {
                  sgc_pageRole: 'own2',
                  sgc_pageName: 'iPdtList',
                  sgc_pageMode: 'show',
                },
                onPrs: null,
              },
            },
        },
        own3: {
          iUserDtl: {
            type:'iconPfx', 
            iconName: 'user',
            pfx:'スタッフ情報',
            role: 'own3',
            page:'iUserDtl',
            sgcd_pageCmns: {
            },
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: 'スタッフ一覧',
              d_pageInfs: {
                sgc_pageRole: 'own2',
                sgc_pageName: 'iUserList',
                sgc_pageMode: 'show',
              },
              onPrs: null,
            },
          },
          iSrvList: {
            type:'iconPfx', 
            iconName: 'list-alt',
            pfx:'入席一覧',
            role: 'own3',
            page:'iSrvList',
            sgcd_pageCmns: {
            },
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: 'スタッフ一覧',
              d_pageInfs: {
                sgc_pageRole: 'own2',
                sgc_pageName: 'iUserList',
                sgc_pageMode: 'show',
              },
              onPrs: null,
            },
          },
          iSrvDtl: {
            b_vsb: false,
            type:'iconPfx', 
            iconName: 'list-alt',
            pfx:'入席情報',
            role: 'own3',
            page:'iSrvDtl',
            sgcd_pageCmns: {
            },
            d_leftBtns: {
              b_vsb: true,
              iconName: 'arrow-left',
              pfx: '戻る',
              d_pageInfs: {
                sgc_pageRole: 'own3',
                sgc_pageName: 'iSrvList',
                sgc_pageMode: 'show',
              },
              onPrs: null,
            },
          },
        }, 
    }

  static _get_leftBtns = (p_pageRole, p_pageName, p_pageMode) => { // p_pageName は未使用
//bf.l('550:{}, {}, {}'.f(p_pageRole, p_pageName, p_pageMode))
    let _r = {};
    let _pageType = (p_pageName?.substr(-4) == 'List') ? 'list' : 'dtl'; // gdd_ftrDefss において定義されていない pageName を考慮
    switch (_pageType) {
      case 'list':
        switch (p_pageMode) {
          case 'show':
            if (
              bf.f(iv.gdd_ftrDefss[p_pageRole]) && 
              bf.f(iv.gdd_ftrDefss[p_pageRole][p_pageName]) && 
              bf.f(iv.gdd_ftrDefss[p_pageRole][p_pageName].d_leftBtns)
            ) {
              _r = iv.gdd_ftrDefss[p_pageRole][p_pageName].d_leftBtns;
            }
            else {
              _r = {
                b_vsb: false,
                iconName: null,
                pfx: null,
                d_pageInfs: null,
                onPrs: null,
              };
            };
          default:
            break;
        };
        break;
      case 'dtl':
        switch (p_pageMode) {
          case 'new':
          case 'edit':
            _r = {
              b_vsb: true,
              iconName: null,
              pfx: null,
              d_pageInfs: null,
              onPrs: null,
            };
            break;
          case 'show':
            if (
              bf.f(iv.gdd_ftrDefss[p_pageRole]) && 
              bf.f(iv.gdd_ftrDefss[p_pageRole][p_pageName]) && 
              bf.f(iv.gdd_ftrDefss[p_pageRole][p_pageName].d_leftBtns)
            ) {
              _r = iv.gdd_ftrDefss[p_pageRole][p_pageName].d_leftBtns;
            }
            else {
              _r = {
//                                b_vsb: true,
                b_vsb: false,
                iconName: null,
                pfx: null,
                d_pageInfs: null,
                onPrs: null,
              };
            };
          default:
            break;
        };
        break;
      default:
        break;
    };
    //
    return _r;
  };

/*
    static myRN_grt_leftBtns = (p_pageRole, p_pageName, p_pageMode) => { // p_pageName は未使用
      let _r = {};
      let _pageType = (p_pageName?.substr(-4) == 'List') ? 'list' : 'dtl'; // gdd_ftrDefss において定義されていない pageName を考慮
      switch (_pageType) {
        case 'list':
          switch (p_pageMode) {
            case 'show':
              if (
                bf.f(iv.gdd_ftrDefss[p_pageRole][p_pageName]) && 
                bf.f(iv.gdd_ftrDefss[p_pageRole][p_pageName].d_leftBtns)
              ) {
                _r = iv.gdd_ftrDefss[p_pageRole][p_pageName].d_leftBtns;
              }
              else {
                _r = {
                  b_vsb: false,
                  iconName: null,
                  pfx: null,
                  d_pageInfs: null,
                  onPrs: null,
                };
              };
            default:
              break;
          };
          break;
        case 'dtl':
          switch (p_pageMode) {
            case 'new':
            case 'edit':
              _r = {
                b_vsb: true,
                iconName: null,
                pfx: null,
                d_pageInfs: null,
                onPrs: null,
              };
              break;
            case 'show':
              if (
                bf.f(iv.gdd_ftrDefss[p_pageRole][p_pageName]) && 
                bf.f(iv.gdd_ftrDefss[p_pageRole][p_pageName].d_leftBtns)
              ) {
                _r = iv.gdd_ftrDefss[p_pageRole][p_pageName].d_leftBtns;
              }
              else {
                _r = {
                  b_vsb: true,
                  iconName: null,
                  pfx: null,
                  d_pageInfs: null,
                  onPrs: null,
                };
              };
            default:
              break;
          };
          break;
        default:
          break;
      };
      //
      return _r;
    };
*/

    static gd_stgs = {
        cLgn: { // ログイン画面に関わる設定
            f_ini: () => {
            },
            b_alwNewUser: false, // ログイン画面において新規登録を使用
            b_usePcy: false, // 新規利用者登録において利用規約を使用
        },
        cCtgDtl: {
            f_ini: () => {
                global.c?.setState({ sgcd_hdrs: bf.p(global.c?.state.sgcd_hdrs, _next => {
                    //
                    _next.pfx = iv._get_hdrPfx('分類一覧');
                    _next.d_leftBtns = iv._get_leftBtns(global.c?.state.sgc_pageRole, global.c?.state.sgc_pageName, global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName]);
                }),
                }, () => {
                });
            },
        },
        cMsgDtl: {
            f_ini: () => {
                global.c?.setState({
                    sgcd_hdrs: bf.p(global.c?.state.sgcd_hdrs, _next => {
                        //
                        _next.pfx = iv._get_hdrPfx('メッセージ');
                        _next.d_leftBtns = iv._get_leftBtns(global.c?.state.sgc_pageRole, global.c?.state.sgc_pageName, global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName]);
                    }),
                }, () => {
                });
            },
        },
        cMsgList: {
            f_ini: () => {
                global.c?.setState({
                    //
                    sgcd_hdrs: bf.p(global.c?.state.sgcd_hdrs, _next => {
                        //
                        _next.pfx = iv._get_hdrPfx('メッセージグループ一覧');
                        _next.d_leftBtns = iv._get_leftBtns(global.c?.state.sgc_pageRole, global.c?.state.sgc_pageName, global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName]);
                    }),
                    sgcd_bdys: bf.p(global.c?.state.sgcd_bdys, _next => {
                        _next.ld_defss = [
                            {
                                type: 'List',
                                pfx: '',
                                state: 'sdd_ct21ss',
                                nextRole: global.c?.state.sgc_pageRole,
                                nextPage: 'cMsgDtl',
                                nextMode: 'show',
                                b_edt: false,
                                b_img: false,
                                b_bdr: false,
                            },
                        ];
                    }),
                });
            },
        },
        cMsgSet: {
            f_ini: () => {
                global.c?.setState({
                    sgcd_hdrs: bf.p(global.c?.state.sgcd_hdrs, _next => {
                        //
                        _next.pfx = iv._get_hdrPfx('メッセージグループ');
                        _next.d_leftBtns = iv._get_leftBtns(global.c?.state.sgc_pageRole, global.c?.state.sgc_pageName, global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName]);
                    }),
                }, () => {
                });
            },
        },
    };

}
